import React, { memo, HTMLProps, ChangeEvent, ReactNode } from 'react'

export interface IRadioOptionProps extends HTMLProps<HTMLInputElement> {
  id: string
  label?: string
  name: string
  value?: string
  selected?: boolean
  disabled?: boolean
  dataTest?: string
  className?: string
  children: ReactNode
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

/**
 * RadioOption - allows for more flexible label content vs  that of Radio component
 */
export const RadioOption = memo<IRadioOptionProps>(
  ({ children, className = '', dataTest, disabled, id, name, onChange, selected, value }) => {
    return (
      <label htmlFor={id} className={`flex ${className}`}>
        <input
          type='radio'
          name={name}
          className='mt1 no-shrink'
          onChange={onChange}
          data-test={dataTest}
          checked={selected}
          value={value}
          id={id}
          disabled={disabled}
        />
        {children}
      </label>
    )
  }
)

export default RadioOption
